import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import _ from "lodash";
import { injectIntl } from "react-intl";

import {
  KeyboardArrowRight,
  Settings,
  Person,
  ExitToApp,
  Home,
} from "components/Icons";
import { IOrder, IInvoice, IDelivery, IUser } from "models/.";
import { URLS, SIDE_MENUS, ROUTES_WITH_ID } from "constants/urlConstants";
import getVar from "constants/.";
import { formatProfileName } from "helpers/formatting";
import AuthManager from "../../screens/auth/auth-manager";
import SettingsMenu from "./SettingsMenu";

import "./Header.scss";
import { configurationsFromFile } from "../../apiUtils";

interface IProps {
  roles: string[];
  match: any;
  user: IUser;
  onHomeClicked: () => void;
  orderItem: IOrder;
  invoiceItem: IInvoice;
  deliveryItem: IDelivery;
  intl: any;
}

class Header extends React.Component<IProps> {
  public logOut = () => {
    configurationsFromFile().then((configs) => {
      AuthManager(configs).logout();
    });
  };

  private openAccountManagement = () => {
    window.open(getVar("ACCOUNTMANAGEMENT_URL"), "_blank");
  };

  private generateMenuItems = () => {
    const {
      match: { params, path },
      intl: { formatMessage },
    } = this.props;
    const menuItems: any = [
      {
        label: formatMessage({ id: "DASHBOARD" }),
        url: "/",
      },
    ];

    _.each(SIDE_MENUS, ({ items }) =>
      _.each(items, (item) => {
        const itemPath = item.url + (_.isEmpty(params) ? "" : "/:id");
        if (itemPath === path) {
          menuItems.push({ ...item, label: formatMessage({ id: item.label }) });

          if (itemPath !== item.url) {
            // if has child with id param
            const route = _.find(ROUTES_WITH_ID, ["path", item.url]) as any;

            if (route) {
              menuItems.push({
                label: route.mainLabel
                  ? formatMessage({ id: route.mainLabel })
                  : `${formatMessage({ id: route.label })} ${_.get(
                      this.props[route.name],
                      route.key,
                      ""
                    )}`,
              });
            } else {
              menuItems.push({
                label: `${formatMessage({ id: item.label })} ${params.id}`,
              });
            }
          }
        } else if (_.includes(path, itemPath)) {
          menuItems.push({ ...item, label: formatMessage({ id: item.label }) });
        }
      })
    );

    return menuItems;
  };

  public render() {
    const {
      roles,
      user: { profile = {} },
      onHomeClicked,
    } = this.props;
    const menuItems = this.generateMenuItems();

    return (
      <div id="header">
        <div className="header-nav">
          {menuItems.map((menuItem, index) => (
            <div key={index} className="breadcrumb-item">
              {index !== menuItems.length - 1 ? (
                <span>
                  <Link to={menuItem.url}>
                    {menuItem.label === "Dashboard" && (
                      <Home className="breadcrumb-item-icon" />
                    )}
                    {menuItem.label}
                  </Link>
                  <KeyboardArrowRight className="breadcrumb-arrow" />
                </span>
              ) : (
                <span>
                  {menuItem.label === "Dashboard" && (
                    <Home className="breadcrumb-item-icon" />
                  )}
                  {menuItem.label}
                </span>
              )}
            </div>
          ))}
        </div>
        <div className="account-container">
          <SettingsMenu
            profileName={formatProfileName(profile.name)}
            items={[
              {
                name: "SETTINGS",
                url: URLS.SETTINGS_URL,
                hidden: !_.includes(roles, "Algemeen"),
                renderIcon: () => <Settings />,
              },
              {
                name: "USERS",
                hidden: !_.includes(roles, "GebruikersBeheer"),
                onClick: this.openAccountManagement,
                renderIcon: () => <Person />,
              },
              {
                name: "LOG_OUT",
                onClick: this.logOut,
                renderIcon: () => <ExitToApp />,
              },
            ]}
          />
          <div className="cnb-logo" onClick={onHomeClicked}>
            <img src="/assets/images/logo.png" id="cnb-logo" />
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter<any>(
  connect((state) => ({
    roles: state.app.roles,
    user: state.app.user,
    orderItem: state.orders.currentItem,
    invoiceItem: state.invoices.currentItem,
    deliveryItem: state.deliveries.currentItem,
  }))(injectIntl(Header))
);
